
<template>
    <div class="peixun">
     <p style="width: 1px; height: 40px;background: #2589ff;transform: rotate(20deg);position: absolute;left: 51%;top: 20px;"></p>
     <div style="color: #000; ">
        <h2 style="text-align: center;font-size: 30px;line-height: 35px;">培训项目</h2>
        <p style="text-align: center;line-height: 30px;">Activity Center</p>
     </div>
     <p style="width: 1px; height: 40px;background: #2589ff;transform: rotate(20deg);position: absolute;left: 49%;"></p>

     
     <div style="width: 1200px; margin: 0 auto;display: flex;flex-wrap: wrap;justify-content: space-between;margin-top: 100px;" >
      

        <div style="width: 270px;margin-top: 50px; border-bottom: 3px solid #0086d1;overflow: hidden;" class="tj1" v-for="item in getContentList"  @click=" openNewAll(item)">
          <img :src="item.img" alt="" style="width: 270px;height: 240px;">
          <h3 class="tj1A" style="">{{item.title}}</h3>
          <p class="tj1B"><span><i class="el-icon-time">

</i>{{item.time1}}</span><span><i class="el-icon-s-check"></i>{{item.num}}</span></p>
<p class="tj1C" style=""><span style="">查看详情</span></p>
        </div>
        
      
     </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
        return {
            getContentList:[],
            total: 0,
            currentPage: 1,
            pageSize: 4,
        }
    },
    mounted() {
        this.$axios
            .get("/system/content/getContentList",  { params:{pageNum: this.currentPage, pageSize: this.pageSize, type: '7' }})
            .then(res => {
                if (res.code == 0) {
                this.getContentList = res.data.rows
                } else {
                this.$message.closeAll();
                this.$message.error(res.msg);
                }
            });
    },
    methods: {
      openNewAll(row){
            sessionStorage.setItem("top", '4');
            this.$router.push({
            path: "/offerACoursedetails",
            query: row
        });
        },
    }
  };
  </script>
  
  <style lang="less">
  .peixun{
      background-image:url("../../../assets/peixun.jpg");
      background-size: cover; /* 背景图片覆盖整个元素 */
      background-repeat: no-repeat; /* 背景图片不重复 */
      background-position: center; /* 背景图片居中 */
      width: 100%; /* 元素宽度 */
      height: 1040px;
      padding: 60px 0 0;
      position: relative;
      .peixunimg{
        img:nth-child(2){
            display: none;
        }
      }
      .peixunimg:hover{
        cursor: pointer;
        span{
            color:#337ab7;
        }
        
        img:nth-child(1){
            display: none;
        }
        img:nth-child(2){
            display: block;
        }
      }
      .tj1A {
      padding: 0 20px;
      color: #4c4c4c;
      font-family: 'montserratregular';
      font-size: 24px;
      margin-bottom: 10px;
    }

    .tj1B {
      padding: 0 20px;
      color: #4c4c4c;
      font-family: 'montserratregular';
      font-size: 14px;
    }

    .tj1C {
      padding: 0 20px;
      margin: 20px 0 50px 0;

      span {
        background: #0086d1;
        color: #fff;
        padding: 8px 20px;
        font-size: 14px;
      }
    }

    .tj1:hover {
      img {
        cursor: pointer;
      }

      .tj1A {
        color: #0086d1;
        cursor: pointer;
      }

      .tj1C {

        span {
          background: #181a1b;
          color: #fff;
          padding: 8px 20px;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
  </style>
  